import type { ReactNode } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { TruncatedTextWithTooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { PLAYBOOK_SUMMARY_HALF_WIDTH } from "./playbookSummaryLayout";

type PlaybookSummaryBadgeCardProps = {
    label: string;
    badge: ReactNode;
    dataAutomation: string;
};

export const PlaybookSummaryBadgeCard = ({ label, badge, dataAutomation }: PlaybookSummaryBadgeCardProps) => (
    <Flex
        alignItems="center"
        justifyContent="space-between"
        gap="12px"
        flex={`1 1 ${PLAYBOOK_SUMMARY_HALF_WIDTH}`}
        maxWidth={PLAYBOOK_SUMMARY_HALF_WIDTH}
        borderRadius="6px"
        border={`1px solid ${colorsPalettes.carbon["50"]}`}
        padding="10px 14px"
        minWidth="0"
        data-automation={dataAutomation}
    >
        <Flex
            flex="1"
            minWidth="0"
        >
            <TruncatedTextWithTooltip
                fontVariant="subtitle2"
                color={colorsPalettes.carbon["500"]}
                width="100%"
            >
                {label}
            </TruncatedTextWithTooltip>
        </Flex>
        {badge}
    </Flex>
);
